import React from 'react'

interface TextareaProps {
	value: string
	onChange: (value: string) => void
	rows?: number
	placeholder?: string
	className?: string
	style?: React.CSSProperties
}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
	({ value, onChange, rows = 5, placeholder, className, style }, ref) => {
		return (
			<textarea
				ref={ref}
				value={value || ''}
				onChange={(e) => onChange(e.target.value)}
				rows={rows}
				className={
					className ||
					'w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent text-xs'
				}
				placeholder={placeholder}
				style={style}
			/>
		)
	}
)

Textarea.displayName = 'Textarea'

export default Textarea


